import React, { useEffect, useState } from 'react'
import EahsForm from '../components/EahsForm'
import { useTranslate } from '../components/TranslationText'
import NetaqInput from '../components/NetaqInput';
import SimpleFileUpload from "../components/SimpleFileUpload";
import axiosInstance from '../axios/axios';
import { useLocation, useNavigate } from 'react-router';
import { formatDate } from '../helper/formatDate';
import Loader from '../components/Loader';
import { isEmail } from '../helper/Validations';
import { eformInput, noDataCard } from '../common/cssclasses';

export default function CourseEnrollmentDate({ toast }) {
    const { translate } = useTranslate();
    const [isSubmiting, setIsSubmitting] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.has("Id")
        ? searchParams.get("Id")
        : '';
    const [agreeOnTermsAndConditions, setAgreeOnTermsAndConditions] = useState(false);
    const [courseDetails, setCorseDetails] = useState({});
    const [loaded, setLoaded] = useState(false);
    const [courseDates, setCorseDates] = useState([]);
    const [showsList, setShowsList] = useState([]);
    const [selectedDate, setSelectDate] = useState(null);
    const [selectedShow, setSelectShow] = useState(null);

    async function getCorseById() {
        try {
            const res = await axiosInstance.get(`/courses/getcoursebyid?id=${id}`);
            if (res.data?.responseCode == 200) {
                setCorseDetails(res.data?.result);
                const dates = res.data?.result?.courseDates;
                const showsList = res.data?.result?.showsList ?? [];
                const formattedDate = dates.map((x) => ({
                    text: x?.date,
                    label: x?.date,
                    value: x?.id,
                    isDisabled: !x?.hasEmptyPlaces ?? false
                }));
                const formattedShowsList = showsList.map((x) => ({
                    text: x?.name,
                    label: x?.name,
                    value: x?.id,
                }));
                setCorseDates(formattedDate);
                setShowsList(formattedShowsList ?? []);
                setLoaded(true)
            }

        } catch (error) {
            console.error('error in get corse Details', error)
            setLoaded(true)
        }

    }



    useEffect(() => {
        getCorseById();
    }, [])




    async function submit() {
        try {
            setIsSubmitting(true);
            if (!selectedDate?.value) {
                toast.error(translate('web.pleaseSelectDate', 'Please Select Date'));
                setIsSubmitting(false);
                return;
            }
            if (courseDetails?.withShowsList == true) {
                if (!selectedShow?.value) {
                    toast.error(translate('web.pleaseSelectShow', 'Please Select Show'));
                    setIsSubmitting(false);
                    return;
                }
            }

            const res = await axiosInstance.post('/courses/submitculturecourseregistration',
                {
                    courseId: id,
                    dateId: selectedDate?.value,
                    showId: courseDates?.withShowsList == true ? selectedShow?.value : null
                });
            if (res.data?.status?.responseCode == "200") {
                toast.success(translate('web.submittedSuccessfully', 'Submitted Successfully'));
                setIsSubmitting(false);
                navigate('/courses');
            } else {
                toast.error(res.data?.status?.detailedResponseCode);
                setIsSubmitting(false);
            }
        } catch (error) {
            setIsSubmitting(false);
            console.error('error in Submiting', error)
        }
    }


    return (
        <div className='container'>
            {!loaded ? <Loader /> :
                <>

                    <div className='row rtl mb-main'>
                        <h2 className='col-12 fw-bold'>
                            {courseDetails?.title}
                        </h2>
                        <div className='col-12 row'>
                            <div className="col-md-2  showDetaisLabel " style={{ width: 'unset' }}>
                                <i className="fa fa-calendar C89C66" style={{ margin: "0px 5px" }}></i>
                                {translate('web.startDate', 'Start Date')}:
                                <span className='ms-1'>{formatDate(courseDetails?.startDate)}</span>
                            </div>
                            <div className="col-md-2  showDetaisLabel " style={{ width: 'unset' }}>
                                <i className="fa fa-calendar C89C66" style={{ margin: "0px 5px" }}></i>
                                {translate('web.endDate', 'end Date')}:
                                <span className='ms-1'>{formatDate(courseDetails?.endDate)}</span>
                            </div>
                        </div>
                    </div>
                    {courseDetails?.isOpenedToRegister && !courseDetails?.isUserRegistered ?
                        <>
                            <EahsForm key={'courseDates'}>
                                <div className={eformInput}>
                                    <NetaqInput
                                        type="select"
                                        listSelect={courseDates}
                                        value={selectedDate}
                                        onChange={(e) => {
                                            setSelectDate(e)
                                        }}
                                        name='date'
                                        label={translate('web.selectDate', 'Select Date')}
                                        placeholder={translate('web.selectDate', 'Select Date')}
                                        required
                                    />
                                </div>
                                {(courseDetails?.withShowsList == true) &&
                                    <div className={eformInput}>
                                        <NetaqInput
                                            type="select"
                                            listSelect={showsList}
                                            value={selectedShow}
                                            required

                                            onChange={(e) => {
                                                setSelectShow(e)
                                            }}
                                            name='show'
                                            label={translate('web.selectdesiredShow', 'Select Desired Show')}
                                            placeholder={translate('web.selectdesiredShow', 'Select Desired Show')}
                                        />
                                    </div>
                                }
                            </EahsForm>
                            <EahsForm key={'termsAndConditions'} title={translate('web.termsAndConditions', 'Terms And Conditions')}>
                                <div className='col-12 '>
                                    <ul>
                                        {courseDetails?.termsList?.map((item) => (
                                            <li className='fw-bold'>
                                                {item}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                                <div className='col-12' style={{ paddingRight: 20, paddingLeft: 20 }}>
                                    <NetaqInput
                                        label={translate('web.iAgreeToTheTermsAndConditions', 'I Agree To The Terms And Conditions')}
                                        name='agreed'
                                        type='checkbox'
                                        onChange={(e) => {
                                            setAgreeOnTermsAndConditions(e.target.checked)
                                        }}
                                    />
                                </div>
                            </EahsForm>
                            <div className='row mt-4'>
                                <div className='col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 text-end ms-auto '>
                                    {isSubmiting ? <Loader /> :
                                        <div className={`btn btn-danger rounded px-5 ${agreeOnTermsAndConditions ? '' : 'disabled'}`} onClick={submit}>
                                            {translate('web.submit', 'Submit')}
                                        </div>
                                    }
                                </div>
                            </div>
                        </> :
                        courseDetails?.isUserRegistered ?
                            <>
                                <div className='row rtl mt-3' >
                                    <div className={noDataCard}>
                                        <h4 className='text-danger text-center'>
                                            {translate('web.youhaveAlreadyRigisterdTothisCorse', 'You have Already Rigisterd To this Corse')}
                                        </h4>
                                    </div>
                                </div>
                            </> : <>
                                <div className='row rtl mt-3' >
                                    <div className={noDataCard}>
                                        <h4 className='text-danger text-center'>
                                            {translate('web.sorryRegistrationIsNotOpenNow', 'Sorry Registration Is Not Open Now')}
                                        </h4>
                                    </div>
                                </div>
                            </>
                    }
                </>
            }
        </div>
    )
}
